
/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components.data').factory('ExecServersResourceFactory', function ($resource, EndPointService) {
	return $resource(EndPointService.execServersEndPoint + '/:id',
			{id: '@id'
			// ------- FOR FUTURE PAGINATION IF NEEDED -----------
			//
			// fetchOffset: '@fetchOffset',
			// fetchLimit: '@fetchLimit'
			},
		{
		'update': {
			method: 'PUT',
			url: EndPointService.execServersEndPoint + '/:id',
			params: {id: '@id'},
			isArray: false
		}

	});
});
